<template>
<div>
  <b-card
    class="light-style"
    footer-tag="footer"
  >
    <b-form>
      <b-form-group label="Login Account Email Address*">
        <b-input
          type="email"
          maxlength="50"
          v-model="update_email_form.email"
          :class="{'is-invalid': $v.update_email_form.email.$error, 'is-valid': !$v.update_email_form.email.$invalid}"
          placeholder="Email Address*"
          autocomplete="off"
          data-lpignore="true"
        />
        <b-form-invalid-feedback v-if="!$v.update_email_form.email.required || !$v.update_email_form.email.email">
          Please provide a valid email address.
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form>
    <template #footer>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          variant="danger"
          :disabled="loading"
          @click="close()"
          class="mr-2"
        >
          <b-spinner v-if="loading" />
          CLOSE
        </b-button>
        <b-button
          variant="success"
          class="submit-btn"
          :disabled="loading"
          type="submit"
          @click="onSubmit($event)"
        >
          <b-spinner v-if="loading" />
          UPDATE
        </b-button>
      </div>
    </template>
  </b-card>
</div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

export default {
  name: 'UpdateEmailFormSection',
  props: ['personData'],
  data () {
    return {
      update_email_form: {
        email: ""
      },
      loading: false
    }
  },
  validations: {
    update_email_form: {
      email: {
        required,
        email
      }
    }
  },
  created() {
    this.update_email_form.email = this.personData.email
  },
  methods: {
    async onSubmit(event) {
      this.$v.$touch();
      event.preventDefault();
      if (this.$v.$invalid) {
        this.$toasted.global.error("Please fill out the required fields.");
      } else {
        this.loading = true;
        const params = {
         "email": this.update_email_form.email
        }
        const response = await this.$http.patch(process.env.VUE_APP_API_URL + `/users/${this.personData.user_id}`,{ user: params })
        if (response !== undefined) {
          this.$toasted.global.success("Updated Successfully")
          this.loading = false;
          this.$emit('updateEmailData', false)
        } else {
          this.loading = false;
        }
      }
    },
    close() {
      this.$emit('updateEmailData', true)
    }
  }
}
</script>
